import {
    extractBlockItems,
    extractBlockMarkdown,
    normalizeResponseBlocks,
} from '../structured/structuredBlockUtils';
import { isClosedFenceBlock } from '../markdown/markdownUtils';

export function stripIncompleteMathForStreaming(text) {
    let value = String(text || '');
    const blockDelims = value.match(/\$\$/g);
    if (blockDelims && blockDelims.length % 2 === 1) {
        const last = value.lastIndexOf('$$');
        if (last >= 0) value = value.slice(0, last);
    }
    return value;
}

export function isCodeFenceComplete(content, language) {
    return isClosedFenceBlock(content, language);
}

export function isMermaidComplete(content) {
    return isClosedFenceBlock(content, 'mermaid');
}

export function isTableStable(content) {
    const lines = String(content || '').split('\n');
    for (let i = lines.length - 1; i >= 0; i -= 1) {
        const line = lines[i];
        if (!line.trim()) continue;
        if (line.includes('|')) {
            return line.trim().endsWith('|') || !line.trimStart().startsWith('|');
        }
        break;
    }
    return true;
}

export function isStreamMarkdownComplete(displayContent, fullContent) {
    return (
        String(displayContent || '').length > 0 &&
        String(displayContent).length === String(fullContent || '').length
    );
}

function segmentTextForBlock(block) {
    const markdown = extractBlockMarkdown(block);
    if (markdown) return markdown;
    if (extractBlockItems(block).length > 0) return '';
    return '';
}

export function buildStreamSegments(answer, blocks) {
    const normalized = normalizeResponseBlocks(blocks);
    if (!normalized.length) {
        return [{ kind: 'markdown', text: String(answer || '') }];
    }
    return normalized.map(block => ({
        kind: 'block',
        block,
        text: segmentTextForBlock(block),
    }));
}

export function resolveStreamingStructuredState(segments, displayContent) {
    const content = String(displayContent || '');
    let consumed = 0;
    const completedBlocks = [];
    let pendingMarkdown = '';

    for (const segment of segments || []) {
        const segLen = String(segment.text || '').length;
        if (content.length >= consumed + segLen) {
            if (segment.kind === 'block') completedBlocks.push(segment.block);
            consumed += segLen;
            continue;
        }
        pendingMarkdown = content.slice(consumed);
        break;
    }

    return { completedBlocks, pendingMarkdown };
}

export function isBlockStreamComplete(block) {
    if (!block || typeof block !== 'object') return false;
    if (extractBlockMarkdown(block)) return true;
    return extractBlockItems(block).length > 0;
}
